import "./block.scss";
import { Component } from "react";
import { SortableContainer, SortableElement, arrayMove } from "react-sortable-hoc";
import { Flex, FlexItem, Button } from "@wordpress/components";
import { MediaUpload } from "@wordpress/block-editor";
const __ = wp.i18n.__;

wp.blocks.registerBlockType("bps-blocks/slider", {
  title: "Splide " + __("slider", "bps-slider-block"),
  icon: "images-alt",
  category: "common",
  attributes: {
    images: { type: "array", default: [{ id: "", front_url: "", block_url: "" }] },
  },
  edit: function (props) {
    let items = props.attributes.images.map((value) => value.id);

    const SortableItem = SortableElement(({ value }) => {
      const imageObj = props.attributes.images.filter((image) => image.id == value)[0];
      const imageIndex = props.attributes.images.map((element) => element.id).indexOf(imageObj.id);
      return (
        <FlexItem>
          <div className="slider-edit-block-element">
            <MediaUpload
              type="image"
              value={imageObj.id}
              onSelect={(imageObj) => {
                const newImages = props.attributes.images.concat([]);
                newImages[imageIndex].id = imageObj.id;
                newImages[imageIndex].front_url = imageObj.url;
                newImages[imageIndex].block_url = imageObj.sizes.thumbnail.url;
                props.setAttributes({ images: newImages });
              }}
              render={(obj) => (
                <div>
                  <Button onClick={obj.open} style={{ display: "inline-block" }}>
                    {imageObj.id ? <img src={imageObj.block_url} onClick={obj.open} /> : __("Select image", "bps-slider-block")}
                  </Button>
                </div>
              )}
            />
            <Button
              isDestructive
              onClick={() => {
                props.setAttributes({ images: props.attributes.images.filter((item, index) => imageIndex !== index) });
              }}
            >
              {__("Remove image", "bps-slider-block")}
            </Button>
          </div>
        </FlexItem>
      );
    });

    const SortableList = SortableContainer(({ items }) => {
      return (
        <ul>
          {items.map((value, index) => (
            <SortableItem key={`item-${value}`} index={index} value={value} />
          ))}
        </ul>
      );
    });

    const SortableImagesList = SortableContainer(({ items }) => {
      return (
        <div className="slider-edit-block">
          <h4>{__("Slider images", "bps-slider-block")}:</h4>
          <Flex justify="flex-start" wrap="true">
            {items.map((value, index) => (
              <SortableItem key={`item-${value}`} index={index} value={value} />
            ))}
          </Flex>
          <Button
            isPrimary
            onClick={() => {
              props.setAttributes({ images: props.attributes.images.concat([{}]) });
            }}
          >
            {__("Add image", "bps-slider-block")}
          </Button>
        </div>
      );
    });

    class SortableComponent extends Component {
      state = {
        items: items,
      };
      onSortEnd = ({ oldIndex, newIndex }) => {
        const new_items = arrayMove(items, oldIndex, newIndex);
        this.setState(({ items }) => ({
          items: arrayMove(items, oldIndex, newIndex),
        }));
        const newImages = props.attributes.images.concat([]);
        newImages.sort(function (a, b) {
          return new_items.indexOf(a.id) - new_items.indexOf(b.id);
        });
        props.setAttributes({ images: newImages });
      };
      render() {
        return <SortableImagesList items={this.state.items} onSortEnd={this.onSortEnd} axis="xy" />;
      }
    }

    return (
      <SortableComponent />

      // return (
      //   <div className="slider-edit-block">
      //     <h4>{__("Slider images", "bps-slider-block")}:</h4>
      //     <Flex className="bps-image-elements ui-sortable" justify="flex-start" wrap="true">
      //       {props.attributes.images.map(function (imageObj, imageIndex) {
      //         return (
      //           <FlexItem>
      //             <div className="slider-edit-block-element ui-sortable-handle">
      //               <MediaUpload
      //                 type="image"
      //                 value={imageObj.id}
      //                 onSelect={(imageObj) => {
      //                   const newImages = props.attributes.images.concat([]);
      //                   newImages[imageIndex].id = imageObj.id;
      //                   newImages[imageIndex].front_url = imageObj.url;
      //                   newImages[imageIndex].block_url = imageObj.sizes.thumbnail.url;
      //                   props.setAttributes({ images: newImages });
      //                 }}
      //                 render={(obj) => (
      //                   <div>
      //                     <Button onClick={obj.open} style={{ display: "inline-block" }}>
      //                       {imageObj.id ? <img src={imageObj.block_url} /> : __("Select image", "bps-slider-block")}
      //                     </Button>
      //                   </div>
      //                 )}
      //               />
      //               <Button
      //                 isDestructive
      //                 onClick={() => {
      //                   props.setAttributes({ images: props.attributes.images.filter((item, index) => imageIndex !== index) });
      //                 }}
      //               >
      //                 {__("Remove image", "bps-slider-block")}
      //               </Button>
      //             </div>
      //           </FlexItem>
      //         );
      //       })}
      //     </Flex>
      //     <Button
      //       isPrimary
      //       onClick={() => {
      //         props.setAttributes({ images: props.attributes.images.concat([{}]) });
      //       }}
      //     >
      //       {__("Add image", "bps-slider-block")}
      //     </Button>
      //   </div>
    );
  },
  save: function (props) {
    return null;
  },
});
